import { useContext } from 'react';

import { PeriodContext } from 'src/contexts';

export const usePeriod = () => useContext(PeriodContext);
